var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4076 6.97642L21.1576 4.76767C20.8764 4.48743 20.4956 4.33008 20.0987 4.33008C19.7017 4.33008 19.3209 4.48743 19.0398 4.76767L10.3501 13.3505L6.91038 10.013C6.62864 9.73365 6.24771 9.57732 5.85097 9.5782C5.45424 9.57908 5.07401 9.7371 4.7935 10.0177L2.5435 12.2677C2.2627 12.5489 2.10498 12.9301 2.10498 13.3275C2.10498 13.7249 2.2627 14.1061 2.5435 14.3874L9.25788 21.1374C9.39717 21.2767 9.56255 21.3872 9.74456 21.4626C9.92657 21.538 10.1216 21.5768 10.3187 21.5768C10.5157 21.5768 10.7108 21.538 10.8928 21.4626C11.0748 21.3872 11.2402 21.2767 11.3794 21.1374L23.4123 9.10173C23.5518 8.96206 23.6625 8.79621 23.7378 8.61368C23.8131 8.43116 23.8517 8.23556 23.8513 8.0381C23.8508 7.84064 23.8114 7.64521 23.7353 7.46302C23.6591 7.28083 23.5478 7.11547 23.4076 6.97642ZM10.3144 20.0789L3.60007 13.3289L5.85007 11.0789C5.8528 11.0812 5.85531 11.0837 5.85757 11.0864L9.82788 14.9386C9.96803 15.0757 10.1563 15.1525 10.3524 15.1525C10.5485 15.1525 10.7368 15.0757 10.8769 14.9386L20.1057 5.82892L22.3501 8.04142L10.3144 20.0789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/_tasks.1b81fbca112147700abc70be5d998081.svg";
export { ForwardRef as ReactComponent };